import EyeIcon from '!svg-react-loader?!images-react-svg/icons/icon-eye.svg';

import classNames from 'classnames';
import React from 'react';
import { getAnalytics } from '../analytics';

export default class PasswordInput extends React.Component {
  constructor() {
    super();
    this.toggleType = this.toggleType.bind(this);
    this.state = {
      type: 'password',
      visible: false,
    };
  }

  toggleType() {
    if (this.state.type === 'password') {
      this.setState({ type: 'text', visible: true });
    } else {
      this.setState({ type: 'password', visible: false });
    }
    getAnalytics().track('Password Reveal Toggle', {
      visible: this.state.visible,
    });
  }

  render() {
    return (
      <div className="PasswordInput__wrapper">
        <input type={this.state.type} {...this.props} />
        <div className="PasswordInput__toggle" onClick={this.toggleType}>
          <EyeIcon
            height="100%"
            className={classNames({
              'PasswordInput__icon--visible': this.state.visible,
              PasswordInput__icon: !this.state.visible,
            })}
          />
        </div>
      </div>
    );
  }
}
